require('./builders/holds_builder.ts');
require('./builders/holdtype_builder.ts');
require('./builders/resolution_types_builder.ts');
require('./commands/load_custom_text_command.ts');
require('./commands/load_hold_resolutions_command.ts');
require('./commands/load_holds_command.ts');
require('./commands/load_holds_list_command.ts');
require('./commands/update_hold_resolutions_command.ts');
require('./components/hold_resolution_collection/hold_resolution_collection_controller.ts');
require('./components/holds_detail_content/holds_detail_content_controller.ts');
require('./components/holds_list_content/holds_list_content_controller.ts');
require('./configuration.ts');
require('./datasources/holds_datasource.ts');
require('./datasources/holdtype_datasource.ts');
require('./hold_modal/hold_explanation_modal.ts');
require('./holds_interface.ts');
require('./models/custom_text_model.ts');
require('./queries/holds_list_query.ts');
require('./queries/holds_priority_feed_query.ts');
require('./queries/holds_queries_module.ts');
require('./routes.ts');
require('./servants/holds_attention_servant.ts');
require('./servants/holds_config_servant.ts');
require('./servants/holds_resolution_servant.ts');
require('./services/holds_service.ts');
require('./types/holds_types.ts');
require('./views/holds_detail/holds_detail_controller.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/core.ts